module.exports = __webpack_public_path__ + "static/img/42.0d74512e.png";